var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticClass:"panel",class:_vm.selectIndex == 1 ? 'homePanel' : ''},[_c('header-component',{attrs:{"selectIndex":_vm.selectIndex},on:{"changeService":_vm.changeService}}),_vm._v(" "),_c('router-view',{attrs:{"seviceIndex":_vm.seviceIndex},on:{"changeService":_vm.changeService}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79bff89a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Index.vue
// module id = CQa9
// module chunks = 6